import React from 'react'
import { Card, CardHeader, Table, CardFooter, Label, FormText } from 'reactstrap'
import { GenerateStatusBadge } from 'domains/customer-refund-voucher/atoms'
import { VOUCHER_GENERATE_FLAG } from 'domains/customer-refund-voucher/constants'
import PriceUtil from 'utils/price-util'
import { GenerateVoucherButton } from 'domains/customer-refund-voucher/atoms'
import PropTypes from 'prop-types'

const propTypes = {
  voucher: PropTypes.shape({
    customer_order_number : PropTypes.string,
    customer_name         : PropTypes.string,
    customer_email        : PropTypes.string,
    voucher_generate_flag : PropTypes.bool,
    total_price           : PropTypes.number,
    voucher_code          : PropTypes.string,
    product_rules         : PropTypes.array
  }),
  handleClickGenerateVoucher: PropTypes.func
}

/**
 * @param {object} refund - customer refund voucher detail
 */
const CustomerRefundVoucherDetailCard = ({
  voucher,
  handleClickGenerateVoucher
}) => {
  const voucherGenerateFlag = voucher.voucher_generate_flag
  let checked               = false
  if (voucher?.product_rules?.length > 0) {
    checked = true
  }
  return (
    <Card>
      <CardHeader>
        Refund Voucher Detail
      </CardHeader>

      <Table hover>
        <tbody>
          <tr>
            <th scope='row'>Order Number</th>
            <td>{ voucher.customer_order_number }</td>
          </tr>
          <tr>
            <th scope='row'>Name</th>
            <td className='text-wrap'>{ voucher.customer_name }</td>
          </tr>
          <tr>
            <th scope='row'>Email</th>
            <td>{ voucher.customer_email }</td>
          </tr>
          <tr>
            <th scope='row'>Generate Status</th>
            <td>{ <GenerateStatusBadge status={ voucher.voucher_generate_flag ? VOUCHER_GENERATE_FLAG.COMPLETED : VOUCHER_GENERATE_FLAG.PENDING } /> }</td>
          </tr>
          <tr>
            <th scope='row'>Total Amount</th>
            <td>{ PriceUtil.format(voucher.total_price) }</td>
          </tr>
          <tr>
            <th scope='row'>Voucher Code</th>
            <td>{ voucher.voucher_code }</td>
          </tr>
          <tr>
            <td colSpan={ 2 }>
              <div className='form-group text-wrap'>
                <Label className='text-gray-light text-capitalize font-weight-bolder text-nowrap'>
                  { 'Cannot Use on Marketing Discount Products' }
                </Label>
                <Label className="custom-toggle">
                  <input
                    type="checkbox"
                    defaultChecked={ checked }
                    onClick={ () => checked = !checked }
                    disabled={ voucherGenerateFlag }
                  />
                  <span
                    className="custom-toggle-slider rounded-circle text-success"
                    data-label-off={ 'No' }
                    data-label-on={ 'Yes' }
                  />
                </Label>
                <FormText>
                  {
                    <>
                      <strong>Yes: </strong>Voucher tidak bisa dipakai untuk product yang di marketing discount.
                      <br />
                      <strong>No: </strong>Voucher bisa dipakai untuk product yang di marketing discount.
                    </>
                  }
                </FormText>
              </div>
            </td>
          </tr>
        </tbody>
      </Table>

      <CardFooter className='text-right'>
        <GenerateVoucherButton
          voucherGenerateFlag={ voucherGenerateFlag }
          handleClickGenerateVoucher={ () => handleClickGenerateVoucher({ cannotUseOnMarketingDiscountProducts: checked }) }
        />
      </CardFooter>
    </Card>
  )
}
CustomerRefundVoucherDetailCard.propTypes = propTypes

export default CustomerRefundVoucherDetailCard
